import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';
import Button from '../modern-components/ui/Button';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center px-4">
      <div className="max-w-2xl mx-auto text-center animate-fade-in">
        {/* 404 Illustration */}
        <div className="mb-8 animate-scale-up">
          <div className="text-9xl font-bold bg-gradient-to-r from-primary-600 to-secondary-600 bg-clip-text text-transparent">
            404
          </div>
        </div>

        {/* Content */}
        <div className="space-y-6">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
            Oops! Page Not Found
          </h1>
          <p className="text-lg text-gray-600 max-w-md mx-auto">
            The page you're looking for seems to have wandered off. Don't worry, it happens to the best of us!
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-6">
            <Button
              variant="primary"
              size="lg"
              leftIcon={<Home className="w-5 h-5" />}
              onClick={() => navigate('/')}
            >
              Go Home
            </Button>
            <Button
              variant="outline"
              size="lg"
              leftIcon={<ArrowLeft className="w-5 h-5" />}
              onClick={() => navigate(-1)}
            >
              Go Back
            </Button>
            <Button
              variant="ghost"
              size="lg"
              leftIcon={<Search className="w-5 h-5" />}
              onClick={() => navigate('/products')}
            >
              Browse Products
            </Button>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="mt-16 grid grid-cols-3 gap-4 max-w-md mx-auto animate-slide-up">
          <div className="bg-white/50 backdrop-blur-sm rounded-xl p-4 border border-white">
            <div className="text-2xl mb-2">🏠</div>
            <div className="text-sm text-gray-600">Home</div>
          </div>
          <div className="bg-white/50 backdrop-blur-sm rounded-xl p-4 border border-white">
            <div className="text-2xl mb-2">📦</div>
            <div className="text-sm text-gray-600">Products</div>
          </div>
          <div className="bg-white/50 backdrop-blur-sm rounded-xl p-4 border border-white">
            <div className="text-2xl mb-2">📞</div>
            <div className="text-sm text-gray-600">Contact</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
